import React, { useEffect, useMemo, useState } from "react";
import { YMaps, Map, Clusterer, Placemark } from "react-yandex-maps";
import ReactDOM from "react-dom";
import ReactDOMServer from "react-dom/server";
import styles from "./index.module.scss";
import Balloon from "../balloon";

const BalloonContentLayout = (layoutFactory, Component) => {
  const html = ReactDOMServer.renderToString(Component);
  const Layout = layoutFactory.createClass(`<div id="balloon">${html}</div>`, {
    build() {
      Layout.superclass.build.call(this);
    },
  });

  return Layout;
};

export default function MaperOld({ points, pointId, height = 500 }) {
  const [ymaps, setYmaps] = useState(null);
  const [mapRef, setMapRef] = useState(null);

  const onPlacemarkClick = () => () => {};

  const pointCoords = useMemo(() => {
    return points
      .map((point) => {
        const gpsN = point.GPS_N || point.gpsLat;
        const gpsS = point.GPS_S || point.gpsLon;
        return gpsN != null && gpsS != null ? [gpsN, gpsS] : null;
      })
      .filter(Boolean);
  }, [points]);

  useEffect(() => {
    if (ymaps && mapRef && pointCoords.length > 0) {
      mapRef.setBounds(ymaps.util.bounds.fromPoints(pointCoords));
    }
  }, [ymaps, mapRef, pointCoords]);

  useEffect(() => {
    if (ymaps && mapRef && pointId) {
      const point = points.find((p) => p.ID === pointId || p.id === pointId);
      if (point) {
        const gpsN = point.GPS_N || point.gpsLat;
        const gpsS = point.GPS_S || point.gpsLon;
        if (gpsN != null && gpsS != null) mapRef.setCenter([gpsN, gpsS]);
      }
      mapRef.setZoom(16);
    }
  }, [pointId, ymaps, mapRef]);

  return (
    <div className={styles.Map}>
      <YMaps query={{ lang: "ru_RU", load: "package.full" }}>
        <Map
          onLoad={(ymaps) => setYmaps(ymaps)}
          className={styles.MapBlock}
          style={{
            height,
          }}
          defaultState={{ center: [0, 0], zoom: 9 }}
          instanceRef={(ref) => {
            if (ref) {
              setMapRef(ref);
            }
          }}
        >
          <Clusterer
            options={{
              preset: "islands#invertedVioletClusterIcons",
            }}
          >
            {ymaps &&
              points.map((point) => {
                const gpsN = point.GPS_N || point.gpsLat;
                const gpsS = point.GPS_S || point.gpsLon;
                const key = point.ID || point.id;
                if (gpsN == null || gpsS == null) return null;
                return (
                  <Placemark
                    modules={[
                      "geoObject.addon.balloon",
                      "geoObject.addon.hint",
                    ]}
                    key={key}
                    geometry={[gpsN, gpsS]}
                    onClick={onPlacemarkClick(point)}
                    onBalloonOpen={() => {
                      ReactDOM.hydrate(
                        <Balloon point={point} pointId={pointId} />,
                        document.getElementById("balloon"),
                      );
                    }}
                    options={{
                      balloonContentLayout: BalloonContentLayout(
                        ymaps.templateLayoutFactory,
                        <Balloon point={point} pointId={pointId} />,
                      ),
                    }}
                  />
                );
              })}
          </Clusterer>
        </Map>
      </YMaps>
      <div className={styles.Link}>
        <div>© Яндекс</div>
        <div>
          &nbsp;
          <a
            href="https://yandex.ru/legal/maps_termsofuse/ru/?lang=ru"
            target="_blank"
            rel="noopener noreferrer"
          >
            Условия использования
          </a>
        </div>
      </div>
    </div>
  );
}
